import styled from 'styled-components';
import Box from '@material-ui/core/Box';

const Wrapper = styled(Box)`
  ${({ theme }) => `
  display: flex;
  flex-direction: column;
  position: relative;
  .CSAForms {
    justify-content: flex-start;
    .vertical-button {
      .MuiBox-root:first-child {
        margin-right: 14px;
      }
      .MuiButtonBase-root {
        margin-top: 29px;
        padding-left: 0;
        padding-right: 0;
        .MuiButton-label {
          padding: 2px 22px;
        }
      }
    }
  }
  .viewReport{
    color: ${theme.colors.LINK_COLOR};
   text-decoration:none;
   cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
  .buttonWrapper {
    display: flex;
    justify-content: flex-end;
    padding-bottom: 2%;
    .advancedDVIR {
      margin-right: 1%;
    }
    button {
      margin-top: 0;
    }
  }
  .quickFilter{
    display: none;
  }
  .circle_red, .circle_yellow, .circle_orange, .circle_green{
    width: 12px;
    height: 12px;
    border-radius: 50%;
  }
  .circle_red {
    background: ${theme.colors.RED};
}
.circle_yellow {
  background: ${theme.colors.WARNING};
}
.circle_orange {
  background: ${theme.colors.LINK_COLOR};
}
.circle_green {
  background: ${theme.colors.GREEN_THREE};
}
  `}
`;
const TopWrapper = styled(Box)`
  ${({ theme }) => `
  display: flex;
  justify-content: space-between;
  .exportContainer .MuiAvatar-root {
    width: 30px;
    height: 30px;
  }
  @media (max-width: ${theme.breakpoints.values.smd}px)  {
    flex-direction: column;
  }
  `}
`;

const TableWrapper = styled(Box)`
  padding-top: 2.5%;
  .noPointer{
    .MuiAvatar-img {
      cursor: unset !important;
    }
     svg: {
      color: #b83730;
    }   
  }
  .driverstatusTitle{
    display: none;
  }
`;

const Styled = { Wrapper, TopWrapper, TableWrapper };

export default Styled;
